// Set a cookie with an optional expiration (in days)
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  // Optionally, you can encode the cookie name and value:
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || "")}${expires}; path=/`;
}
// Get a cookie by name
function getCookie(name) {
  const nameEQ = `${encodeURIComponent(name)}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(nameEQ) === 0) {
      // Optionally, decode the cookie value:
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
}
document.addEventListener('DOMContentLoaded', () => {
  const elementToToggle = document.querySelector('.product-results');
  if (!elementToToggle) return; // No element found, exit early
  const SESSION_DURATION = 60000; // 1 day in milliseconds
  const COOKIE_NAME = 'first_visit_product_results';
  const now = Date.now();
  const firstVisit = getCookie(COOKIE_NAME);
  let displayStyle;
  if (!firstVisit) {
    // New visitor: set cookie and hide the element
    setCookie(COOKIE_NAME, now, 365);
    displayStyle = 'none';
  } else {
    const firstVisitTime = parseInt(firstVisit, 10);
    // If the visit is within the session duration, hide the element; otherwise, show it.
    displayStyle = (now - firstVisitTime) < SESSION_DURATION ? 'none' : 'block';
  }
  elementToToggle.style.display = displayStyle;
});